import Vue from "vue";
import { getBasketPartial } from "../basket/BasketActions";

export const getDocuments = ({ dispatch }, id) => {
  dispatch("LOADING", true);
  Vue.http.get("api/v1/Documents", {fileTypeId: id}).then(function (response) {
    dispatch("DOCUMENTS_LOADED", response.data);
  }, function (response) {
    dispatch("LOADING_ERROR");
  });
};

export const getProductDocuments = ({ dispatch }, product) => {
  dispatch("LOADING", true);
  Vue.http.get("api/v1/Documents", product).then(function (response) {
    dispatch("DOCUMENTS_LOADED", response.data);
  }, function (response) {
    dispatch("LOADING_ERROR");
  });
};

export const basketDocument = ({ dispatch }, item) => {
  dispatch("LOADING_BASKET");
  Vue.http.post("api/v1/Documents/AddToBasket", item).then(function (response) {
    getBasketPartial({dispatch});
  });
};

export const mailDocument = ({ dispatch }, item) => {
  Vue.http.post("api/v1/Documents/SendByMail", item).then(function (response) {
    dispatch("MAIL_SENT");
  });
};

export const downloadDocument = ({ dispatch }, item) => {
  dispatch("DOWNLOAD", "/api/v1/Documents/Download", item);
};

export const basketBrochure = ({ dispatch }, item) => {
  dispatch("LOADING_BASKET");
  Vue.http.post("api/v1/Documents/AddBrochureToBasket", item).then(function (response) {
    getBasketPartial({dispatch});
  });
};

export const downloadBrochure = ({ dispatch }, item) => {
  dispatch("DOWNLOAD", "/api/v1/Documents/DownloadBrochure", item);
};

export const mailBrochure = ({ dispatch }, item) => {
  dispatch("MAIL_SENDING");
  Vue.http.post("api/v1/Documents/SendBrochureByMail", item).then(function (response) {
    dispatch("MAIL_SENT");
  });
};



// WEBPACK FOOTER //
// ./src/views/documents/DocumentsActions.js